// akhila 2/12/2022 3075234474 adding copy functionality
// akhila 3/12/2022 3075234474 fixed copy functionality issue
// Lalitha 12/23/2022 3075234474 Added reusable Validation in code
// sai krisha 30/12/2022 3075234474 add code description values
// dilip 01/02/2022 3075234474 fixed copy code issue
// Sohel 02/13/2023 3075234474  WorkQueue validation changes
// suresh peddavoora 03/01/2023 3075234474 new ui changes
// sohel 03/06/2023 3075234474 Added validation message for existing value
// Akhila 06/07/2023 3075234474 Added code and description
// Ravi 07/22/2023 3075234474 Added limit char Validation in code and Description
// Ravi 07/24/2023 3075234474  removed upperCase from workQueue Name
// Ravi 07/26/2023 3075234474  removed multiple hypen validation from workQueue Name

import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import * as Yup from 'yup';
import ErrorBoundaryForComponents from './../../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from './../../../../themes/ThemeProvider';
import PageLoader from './../../../../components/PageLoader/index';
import BreadCrums from '../../../../util/BreadCrum';
import {getAllWqCodeData, postCopyWorkQueue} from '../../../../redux/reducers/WorkQueueSetup';

const CopyWorkQueue = ({oldReportCode, oldReportId, codeAndDescription}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {iscopyLoading, wqCodeData} = useSelector(({addWorkQueue}) => addWorkQueue);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    reportcode: '',
    title: '',
    description: '',
  };

  const checkReportCodeExist = (value) => {
    if (wqCodeData && wqCodeData?.length > 0 && value) {
      const ar = [];
      wqCodeData?.filter((i) => {
        if (
          i?.workqueueName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkReportCodeAlreadyExist = (value) => {
    if (wqCodeData && wqCodeData?.length > 0 && value) {
      const ar = [];
      wqCodeData?.forEach((i) => {
        if (
          i?.workqueueName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    reportcode: Yup.string()
      .required('Work Queue Name is required')
      .max(25, 'Work Queue Name cannot exceed 25 characters')
      .test(
        'reportCode',
        'Work Queue Name is already in use',
        (value) => !checkReportCodeExist(value),
      )
      .test(
        'reportCode',
        'Work Queue Name has already been used in the past',
        (value) => !checkReportCodeAlreadyExist(value),
      ),
    description: Yup.string()
      .required('Work Queue Description is required')
      .max(100, 'Work Queue Description cannot exceed 100 characters'),
  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        oldWorkQueueId: oldReportId ? oldReportId : 0,
        oldworkqueueName: codeAndDescription?.workqueueName ? codeAndDescription?.workqueueName : '',
        workQueueDescription: values?.description ? values?.description.trimStart() : '',
        workQueueId: 0,
        workqueueName: values?.reportcode ? values?.reportcode.trimStart() : '',
      };
      dispatch(postCopyWorkQueue(data));
    }
  };

  useEffect(() => {
    dispatch(getAllWqCodeData('WQ'));
  }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Name'}
                    code={codeAndDescription?.workqueueName}
                    description={'Description'}
                    descriptionValue={codeAndDescription?.workqueueDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={12} lg={3} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Work Queue Name"
                              margin="dense"
                              name="reportcode"
                              variant="outlined"
                              value={values?.reportcode}
                              label="Work Queue Name"
                              inputProps={{maxLength: 25}}
                              required
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.reportcode}
                              error={Boolean(errors.reportcode && touched.reportcode)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.reportcode && errors.reportcode}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={12} lg={9} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Work Queue Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Work Queue Description"
                              inputProps={{maxLength: 100}}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {iscopyLoading && <PageLoader />}
    </>
  );
};

export default CopyWorkQueue;
